// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
export var textDefault = `#414141`;
export var textInactive = `#b8b8b8`;
export var primary = `#492ead`;
export var secondary = `#dd8500`;
export var secondaryDarker = `#b76f02`;
export var primaryDarker = `#381d9d`;
export var greyLight = `#fbfbfb`;
export var greyDark = `#eaeaea`;
export var grey = `#9d9d9d`;
export var info = `#c5e7ff`;
export var cancel = `#ffa4a4`;
export var yes = `#007e29`;
export var no = `#d40000`;
export var noDarker = `#c30000`;
export var purple = `#af00fc`;
export var pink = `#eb67a2`;
export var red = `#ef4e0f`;
export var orange = `#ff7d00`;
export var gold = `#968f00`;
export var blue = `#6600de`;
export var darkPink = `#b63b9f`;
export var green = `#33b09d`;
export var cyan = `#00a3ce`;
export var brown = `#8c6938`;
export default ___CSS_LOADER_EXPORT___;
